import { Component, OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ClipboardService } from 'ngx-clipboard';
@Component({
  selector: 'app-successful-reset',
  templateUrl: './successful-reset.component.html',
  styleUrls: ['./successful-reset.component.scss']
})
export class SuccessfulResetComponent implements OnInit {
  userData:any
  passwordForm: FormGroup;
  copyButtonClicked = false;
  hide = true;
  constructor(
    private dialogRef: MatDialogRef<SuccessfulResetComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private fb:FormBuilder,
    private clipboardService: ClipboardService,
  ) { 
    // console.log(this.data)
    this.userData = this.data;
    this.passwordForm = this.fb.group({
      "suggesPass":[{value: '', disabled: true} ,Validators.required],
  });
  
  }

  ngOnInit() {
    // console.log(this.data)
  }
  copyText(){
    this.clipboardService.copyFromContent(this.data.newPassword);
    this.copyButtonClicked = true;
  }
  close() {
    this.dialogRef.close();
}
showPassword(){
  this.hide = !this.hide;
  
}
}
